import { Capacitor } from '@capacitor/core';

/**
 * Determines if the current platform is mobile web (not native app)
 * by checking user agent and Capacitor platform.
 */
export function isMobileWeb(): boolean {
  // If we're in a native app (iOS/Android), this is not mobile web
  if (Capacitor.isNativePlatform()) {
    return false;
  }

  // Check if we're in a browser environment
  if (typeof navigator === 'undefined') {
    return false;
  }

  // Check user agent for mobile devices
  const ua = navigator.userAgent.toLowerCase();
  const isMobileDevice =
    /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(ua);

  return isMobileDevice;
}

/**
 * Determines the mobile platform (iOS or Android) from user agent.
 * Returns null if platform cannot be determined or is not mobile.
 */
export function getMobilePlatform(): 'ios' | 'android' | null {
  if (typeof navigator === 'undefined') {
    return null;
  }

  const ua = navigator.userAgent.toLowerCase();
  if (/iphone|ipad|ipod/.test(ua)) {
    return 'ios';
  }
  if (/android/.test(ua)) {
    return 'android';
  }
  return null;
}

/**
 * Determines if the current platform is Android mobile web (not native app).
 * Used to redirect Android web users to the Play Store while allowing iOS web users.
 */
export function isAndroidMobileWeb(): boolean {
  return isMobileWeb() && getMobilePlatform() === 'android';
}
